import Mock from 'mockjs'

function fakeSuccess(data) {
    const json = { code: 200, success: true, msg: '操作成功' }
    json.data = data
    return json
}

export default ({ mock }) => {
    if (!mock) return;
    // 工作台-头部信息
    let topJson = {
        topData: {
            callIndex: 2,
            ranking: "0/0",
            fulfillIndex: 0
        }
    }
    // 工作台-工作信息统计
    let workInfoJson = {
        seriesDataList: [
            { value: 3, name: "关爱青少年" },
            { value: 0, name: "禁毒进校园" },
            { value: 0, name: "健康教育" },
            { value: 1, name: "防艾宣传" },
            { value: 1, name: "助残助盲" },
            { value: 0, name: "健康进校园" },
            { value: 0, name: "文明交通" },
            { value: 7, name: "志愿服务" },
            { value: 2, name: "法制进校园活动" },
            { value: 0, name: "关爱留守困境儿童" },
            { value: 0, name: "心理辅导" },
            { value: 0, name: "心理援助" },
            { value: 0, name: "社区矫正" },
            { value: 0, name: "维权案件" },
            { value: 0, name: "活动发布" },
        ]
    }
    // 工作台-案件类型
    let caseTypeJson = {
        seriesList: [
            {
                name: '聚众斗殴罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '寻衅滋事',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '校园霸凌',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '故意伤害',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '校园严重违纪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '绑架罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '敲诈勒索罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '交通肇事罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '抢夺罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '盗窃罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '诈骗罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '抢劫罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '容留他人吸毒',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '贩卖毒品罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '强奸罪',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '强制猥亵妇女',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '猥亵儿童',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '服务救助',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '实物救助',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },
            {
                name: '大病救助',
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
            },   
        ]
    }

    // 工作台-头部信息
    Mock.mock(
        /\/api\/blade-stat\/desk\/workbenchTopData/,
        'get',
        fakeSuccess(topJson)
    )
    // 工作台-工作信息统计
    Mock.mock(
        /\/api\/blade-stat\/desk\/workInfoData/,
        'get',
        fakeSuccess(workInfoJson)
    )
    // 工作台-案件类型
    Mock.mock(
        /\/api\/blade-stat\/desk\/caseTypeData/,
        'get',
        fakeSuccess(caseTypeJson)
    )
}
